import {injectable} from 'inversify';

import type {Destructible} from '../../utils/store';

import {storage} from '../../utils/storage';

@injectable()
export class LocalStorageService implements Destructible {
  destruct = () => {};

  async clear() {
    return storage.clear();
  }

  async getItem(key: string) {
    return storage.getItem(key);
  }

  async removeItem(key: string) {
    return storage.removeItem(key);
  }

  async setItem(key: string, val: string) {
    return storage.setItem(key, val);
  }
}

export namespace LocalStorageService {}
